import { useQuery } from '@tanstack/react-query';
import { getInspectionAttachments } from '../services/InspectionAttachmentsService';
import { inspectionAttachmentsKeys } from './queryKeys';
export function useInspectionAttachments(inspectionId) {
    return useQuery({
        queryKey: inspectionAttachmentsKeys.inspection(inspectionId),
        queryFn: () => getInspectionAttachments(inspectionId),
        enabled: !!inspectionId,
        staleTime: 30000
    });
}
